export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    setOpenLogHtml({commit}) {
        commit('setOpenLogHtml');
    },
    setCloseLogHtml({commit}) {
        commit('setCloseLogHtml');
    }
}
